import { absoluteApiV1Path } from '../lib/api'

export const manualCategorySections = [
  { id: 'sales', label: '영업지원' },
  { id: 'customer', label: '고객지원' },
  { id: 'design', label: '설계지원' },
  { id: 'work', label: '업무지원' },
  { id: 'admin', label: '관리' },
  { id: 'app', label: '앱 매뉴얼' },
  { id: 'other', label: '기타' },
]

export const quickStartGuideSections = [
  {
    id: 'sales-management',
    title: '영업관리',
    summary: '내 정보와 공개 페이지를 정리하고, 들어온 상담 DB를 확인하는 흐름입니다.',
    steps: [
      { label: '내 정보에서 사진 업로드', manualId: 'profile' },
      { label: '모바일명함', manualId: 'public-card' },
      { label: '개인홈페이지', manualId: 'public-landing' },
      { label: '홍보용페이지', manualId: 'category-landing-pages' },
      { label: 'DB수집관리', manualId: 'consultations' },
    ],
  },
  {
    id: 'customer-management',
    title: '고객관리',
    summary: '고객 등록부터 만기, 설문, 상담 보조 도구까지 고객 관리에 필요한 메뉴입니다.',
    steps: [
      { label: '고객등록하기', manualId: 'customers' },
      { label: '보험만기대장관리', manualId: 'maturity-ledger' },
      { label: '설문활용하기', manualId: 'survey-management' },
      { label: '고객지원도구 활용', manualId: 'customer-support-tools' },
    ],
  },
  {
    id: 'customer-consulting',
    title: '고객상담',
    summary: '고객 상담 중 자주 쓰는 분석, 설계, 청구 기능을 모았습니다.',
    steps: [
      { label: '진료정보분석', manualId: 'health-analysis' },
      { label: '숨은보험금찾기', manualId: 'hidden-insurance-money' },
      { label: '화재보험설계', manualId: 'fire-building-registry' },
      { label: '보험금청구', manualId: 'claims' },
    ],
  },
  {
    id: 'work-management',
    title: '업무관리',
    summary: '업무 자료 확인, 일정 관리, 교육 참여에 필요한 메뉴입니다.',
    steps: [
      { label: '보험사소식지', manualId: 'insurer-newsletters' },
      { label: '보험사전산', manualId: 'insurer-systems' },
      { label: '일정관리', manualId: 'work-calendar' },
      { label: '교육/클래스', manualId: 'education-center' },
    ],
  },
  {
    id: 'organization-management',
    title: '조직관리',
    summary: '조직 정보, 배너, 구성원, 원수사 담당자, 조직 현황을 관리하는 흐름입니다.',
    steps: [
      { label: '조직생성/수정', manualId: 'orgs' },
      { label: '조직배너', manualId: 'org-banners' },
      { label: '조직원 관리', manualId: 'users' },
      { label: '원수사담당자관리', manualId: 'users' },
      { label: '조직대시보드', manualId: 'org-dashboard' },
    ],
  },
]

// 빠른 시작은 추후 다시 공개할 수 있도록 데이터만 보존하고, 현재 이용가이드에서는
// 아래의 문서형 시작 가이드를 첫 화면으로 사용한다.
export const supportGuideIntroArticles = [
  {
    id: 'getting-started',
    title: '설계EZ 시작하기',
    categoryLabel: '처음 시작하기',
    summary: '설계EZ는 회원가입 신청부터 시작합니다. 개인으로 이용하는지, 단체계약 조직에 소속되어 이용하는지에 맞춰 가입한 뒤 승인된 계정으로 로그인하세요.',
    sections: [
      {
        id: 'personal-signup',
        title: '개인회원으로 가입하기',
        image: 'images/svc-signup-form.png',
        imageAlt: '설계EZ 회원가입 신청 화면',
        steps: [
          {
            title: '회원가입 신청을 여세요',
            description: '로그인 화면 하단의 회원가입 신청을 누르면 가입 화면으로 이동합니다.',
          },
          {
            title: '기본 정보를 입력하세요',
            description: '이메일, 이름, 휴대폰 번호, 생년월일과 비밀번호를 입력하고 이메일과 휴대폰 번호의 중복 여부를 확인하세요.',
          },
          {
            title: '표시할 조직명을 입력하세요',
            description: '개인회원은 설계의뢰와 리포트에 표시할 조직명을 입력합니다. 단체계약 조직에 소속되어 있다면 아래 조직회원 절차로 진행하세요.',
          },
          {
            title: '필수 약관에 동의하고 신청하세요',
            description: '필수 약관에 동의한 뒤 가입 신청을 누릅니다. 가입 신청이 승인되면 입력한 이메일과 비밀번호로 로그인할 수 있습니다.',
          },
        ],
      },
      {
        id: 'organization-signup',
        title: '조직회원으로 가입하기',
        image: 'images/svc-signup-form.png',
        imageAlt: '설계EZ 회원가입 신청 화면',
        steps: [
          {
            title: '단체계약 조직 소속 여부를 선택하세요',
            description: '가입 화면에서 단체계약 중인 조직에 속해 있다면 체크합니다. 개인회원으로 가입할 때는 선택하지 않아도 됩니다.',
          },
          {
            title: '소속 조직을 검색해 선택하세요',
            description: '조직 검색을 눌러 소속된 조직을 찾고 선택합니다. 검색 결과에 없으면 개인회원으로 가입할 수 있습니다.',
          },
          {
            title: '신청 역할과 동의 내용을 확인하세요',
            description: '조직에서 맡은 역할을 선택하고, 조직 관리자에게 제공되는 업무·이용 현황 조회 권한 안내를 확인한 뒤 동의합니다.',
          },
          {
            title: '가입 신청 후 승인을 기다리세요',
            description: '가입 신청이 승인되면 입력한 이메일과 비밀번호로 로그인할 수 있습니다. 승인 전에는 로그인할 수 없습니다.',
          },
        ],
      },
      {
        id: 'after-signup',
        title: '가입한 뒤 처음 확인할 것',
        image: 'images/svc-signup-dashboard.png',
        imageAlt: '설계EZ 대시보드 화면',
        steps: [
          {
            title: '가입한 이메일로 로그인하세요',
            description: '승인된 계정으로 로그인한 뒤 대시보드에서 오늘 처리할 업무와 일정을 먼저 확인하세요.',
            manualId: 'personal-task-board',
          },
          {
            title: '내 정보와 연락처를 확인하세요',
            description: '고객에게 보여지는 이름, 사진, 연락처를 최신 정보로 정리하면 모바일명함과 개인홈페이지에도 같은 정보가 반영됩니다.',
            manualId: 'profile',
          },
          {
            title: '지금 필요한 업무부터 시작하세요',
            description: '고객 등록, 상담 준비, 일정 관리처럼 지금 가장 필요한 메뉴 하나부터 사용해 보세요.',
          },
        ],
      },
    ],
  },
  {
    id: 'installation',
    title: '설계EZ 설치하기',
    categoryLabel: '처음 시작하기',
    summary: '설계EZ는 별도 프로그램 설치 없이 웹 브라우저에서 이용할 수 있습니다. 가입한 이메일로 로그인한 뒤 내 정보와 자주 쓰는 메뉴를 확인하세요.',
    sections: [
      {
        id: 'web-start',
        title: '웹에서 시작하기',
        image: 'images/01-login.png',
        imageAlt: '설계EZ 로그인 화면',
        steps: [
          {
            title: '이메일로 가입하거나 로그인하세요',
            description: '처음 이용한다면 회원가입을 완료한 뒤, 등록한 이메일과 비밀번호로 로그인합니다.',
          },
          {
            title: '자주 쓰는 브라우저에서 열어두세요',
            description: '고객 관리와 상담 준비처럼 화면을 넓게 보는 업무는 웹에서 편하게 이용할 수 있습니다.',
          },
        ],
      },
      {
        id: 'first-check',
        title: '처음 로그인한 뒤 확인할 것',
        image: 'images/11-profile.png',
        imageAlt: '설계EZ 내 정보 화면',
        steps: [
          {
            title: '내 정보와 연락처를 확인하세요',
            description: '고객에게 노출되는 이름, 사진, 연락처가 최신 정보인지 먼저 확인해 주세요.',
            manualId: 'profile',
          },
          {
            title: '필요한 메뉴부터 살펴보세요',
            description: '영업, 고객관리, 상담, 업무관리 중 지금 가장 필요한 메뉴 하나부터 따라 해 보면 충분합니다.',
          },
        ],
      },
    ],
  },
]
const categoryBySlug = {
  profile: 'sales',
  'public-card': 'sales',
  'public-landing': 'sales',
  'org-homepage': 'sales',
  'category-landing-pages': 'sales',
  'category-landing': 'sales',
  consultations: 'sales',

  'customer-work-queue': 'customer',
  customers: 'customer',
  'support-customers': 'customer',
  'maturity-ledger': 'customer',
  'customer-support-tools': 'customer',
  'survey-management': 'customer',
  'sales-images': 'customer',
  surveys: 'customer',
  claims: 'customer',

  'health-analysis': 'design',
  health: 'design',
  'hidden-insurance-money': 'design',
  'fire-building-registry': 'design',
  'uw3nn-exceptions': 'design',
  requests: 'design',
  'fire-insurance': 'design',

  'personal-task-board': 'work',
  'insurer-newsletters': 'work',
  'insurer-systems': 'work',
  'work-calendar': 'work',
  calendar: 'work',
  'education-center': 'work',
  'work-support-tools': 'work',
  education: 'work',

  notices: 'admin',
  orgs: 'admin',
  'org-banners': 'admin',
  users: 'admin',
  'org-dashboard': 'admin',

  'app-home-briefing': 'app',
  'app-customers': 'app',
  'app-maturity-ledger': 'app',
  'app-health-analysis': 'app',
  'app-hidden-insurance-money': 'app',
  'app-widgets': 'app',
}

const categoryLabelById = Object.fromEntries(manualCategorySections.map((section) => [section.id, section.label]))

/** slug별 서버 내장 HTML·PDF (DB와 동일 규칙). */
function builtinManualUrls(slug) {
  return {
    viewUrl: absoluteApiV1Path(`public/support-guide/manuals/by-slug/${slug}/html`),
    downloadUrl: absoluteApiV1Path(`public/support-guide/manuals/by-slug/${slug}/pdf`),
  }
}

export function manualCategoryForId(id, fallbackCategory = '') {
  return fallbackCategory || categoryBySlug[id] || 'other'
}

export function withManualCategory(item) {
  const category = manualCategoryForId(item?.id || item?.slug, item?.category)
  return {
    ...item,
    category,
    categoryLabel: item?.categoryLabel || categoryLabelById[category] || categoryLabelById.other,
  }
}

export function groupManualItems(items) {
  const normalized = (items || []).filter((item) => (item?.id || item?.slug) !== 'kakao-bulk-sender').map(withManualCategory)
  return manualCategorySections
    .map((section) => ({
      ...section,
      items: normalized.filter((item) => item.category === section.id),
    }))
    .filter((section) => section.items.length > 0)
}

const primaryFallbackRows = [
  ['profile', '내 정보', '프로필 사진과 기본 정보를 정리해 모바일명함과 개인 홈페이지에 반영하는 가이드입니다.'],
  ['public-card', '모바일명함', '프로필, 연락처, 소개 문구, 대표 이미지와 공개 링크를 정리해 고객에게 공유하는 모바일 명함 가이드입니다.'],
  ['public-landing', '개인홈페이지', '개인 소개, 상담 가능 분야, 문의 동선, 공유 링크를 구성하는 개인 홈페이지 제작·운영 가이드입니다.'],
  ['org-homepage', '조직홈페이지', '조직 소개, 리크루팅, 문의 접수, 공개 섹션을 구성해 조직 단위 홈페이지를 운영하는 가이드입니다.'],
  ['category-landing-pages', '홍보용페이지', '상품이나 상담 주제에 맞는 페이지를 만들고 고객 문의를 DB수집관리로 연결합니다.'],
  ['consultations', 'DB수집관리', '홍보용페이지와 상담 신청으로 들어온 고객 문의를 확인하고 담당자와 진행 상태를 관리합니다.'],

  ['customer-work-queue', '고객업무허브', '고객 정보, 계약, 보장분석, 상담 이력을 기준으로 지금 확인할 고객을 자동으로 분류하고 후속 업무를 관리합니다.'],
  ['customers', '고객관리', '고객 등록, 검색, 상세 이력, 상담 메모, 진료정보분석·숨은보험금찾기 연결까지 관리하는 기본 가이드입니다.'],
  ['maturity-ledger', '보험만기대장', '고객의 만기와 갱신 예정 계약을 확인하고 연락, 상담, 종료 처리까지 한곳에서 관리합니다.'],
  ['customer-support-tools', '고객지원도구', '실비 예상, 청구 서류, 보험나이, 병원·비급여·의약품 조회와 문구 점검 도구를 상담 준비에 활용하는 가이드입니다.'],
  ['survey-management', '설문관리', '상담 전에 필요한 질문을 만들고 고객 응답을 상담과 후속 업무에 연결합니다.'],
  ['sales-images', '이미지자료실', '상담, 홍보, 공지에 활용할 이미지 자료를 검색하고 내려받아 고객 커뮤니케이션에 활용하는 가이드입니다.'],
  ['claims', '보험금청구', '고객 정보, 청구서식, 첨부서류, 서명, PDF 생성, 팩스 발송 결과까지 처리하는 청구 가이드입니다.'],

  ['health-analysis', '진료정보분석', '고객 인증을 거쳐 최근 5년 진료정보를 확인하고 상담에 필요한 내용을 정리합니다.'],
  ['hidden-insurance-money', '숨은보험금찾기', '고객의 의료비·실손 수령 자료를 기준으로 미청구 가능성을 확인하고 고객 안내 자료로 연결하는 가이드입니다.'],
  ['fire-building-registry', '화재보험설계', '주소와 건축물 정보를 확인하고 업종·특약을 정리해 설계의뢰까지 이어갑니다.'],
  ['uw3nn-exceptions', '예외질환조회', '현재 21개 보험사의 29,746개 예외질환 항목을 조회할 수 있으며 데이터는 계속 업데이트됩니다.'],
  ['requests', '설계관리', '설계 요청을 등록하고 담당자 배정, 진행 상태, 코멘트, 첨부파일을 관리하는 가이드입니다.'],

  ['personal-task-board', '내 업무보드', '개인 할 일, 고객 후속 조치, 상담 메모, 업무 상태를 한 곳에서 관리하는 개인 업무보드 가이드입니다.'],
  ['insurer-newsletters', '보험사소식지', '보험사별 공지·소식지를 조회하고 상담 또는 업무 참고 자료로 활용하는 가이드입니다.'],
  ['insurer-systems', '보험사전산', '보험사 전산 접속 정보, 업무 링크, 로그인 주의사항을 확인하는 업무지원 가이드입니다.'],
  ['work-calendar', '일정관리', '개인·팀 일정, 고객 연락, 만기 일정, 청구 일정 등을 캘린더로 관리하는 가이드입니다.'],
  ['education-center', '교육/클래스', '교육 과정 조회, 신청, 수강 상태, 댓글·자료 확인까지 관리하는 교육/클래스 가이드입니다.'],
  ['work-support-tools', '업무지원도구', '증권전달북, 3종확인서, 질병코드 검색을 이용해 반복 업무를 빠르게 처리하는 가이드입니다.'],

  ['notices', '공지', '조직 공지와 업무 안내를 확인하고 권한이 있는 사용자는 공지 작성·수정·노출 상태를 관리하는 가이드입니다.'],
  ['orgs', '조직관리', '조직 생성, 상하위 구조, 조직 정보, 상태, 권한 범위를 관리하는 관리자용 가이드입니다.'],
  ['org-banners', '조직배너', '조직별 배너 이미지, 공개 기간, 노출 위치를 설정해 사용자 화면과 공개 화면에 반영하는 가이드입니다.'],
  ['users', '사용자/담당자', '사용자 계정, 역할, 소속 조직, 담당자 상태, 잠금·활성 상태를 관리하는 가이드입니다.'],
  ['org-dashboard', '조직 대시보드', '조직별 업무 현황, 구성원 활동, 고객·의뢰·상담 지표를 확인하는 관리자용 대시보드 가이드입니다.'],

  ['app-home-briefing', '앱 홈/업무브리핑', '모바일에서 오늘 처리할 업무, 고객 후속 일정, 업무 브리핑을 빠르게 확인하는 가이드입니다.'],
  ['app-customers', '앱 고객관리', '외부에서도 고객 정보와 상담 이력을 확인하고 다음 업무를 이어 가는 가이드입니다.'],
  ['app-maturity-ledger', '앱 보험만기대장', '모바일에서 만기 예정 고객과 후속 연락 일정을 확인하는 가이드입니다.'],
  ['app-health-analysis', '앱 진료정보분석', '모바일에서 진료정보분석 결과를 확인하고 상담 핵심을 정리하는 가이드입니다.'],
  ['app-hidden-insurance-money', '앱 숨은보험금찾기', '모바일에서 숨은보험금 가능성 조회 결과를 확인하고 고객 안내에 활용하는 가이드입니다.'],
  ['app-widgets', '앱 위젯/빠른 실행', '자주 쓰는 기능을 모바일 홈에서 빠르게 실행하는 가이드입니다.'],
]

/**
 * 이용 가이드 — API 실패 시에만 쓰는 폴백 데이터.
 * 운영 반영 값은 DB(`support_guide_manuals`) + `/public/support-guide/manuals` 입니다.
 */
export const supportGuideManualFallbackItems = primaryFallbackRows.map(([id, title, summary]) => (
  withManualCategory({
    id,
    title,
    summary,
    ...builtinManualUrls(id),
  })
))
